export const blockIconsAndroidFlashlightOnNew = (
	<span className='material-symbols-outlined'>flashlight_on</span>
);
